export default {
  back: "Back",
  blog_search_text: "Search...",
  all_category_text: "All",
  rating_alt : "Rating",
  notfoundtitle : "404 – Page Not Found",
  notfoundcontent: "We can't find the page you are looking for! Head back to",
  quotes: "quotes",
  /**Auth */
  name_placeholder: "NAME",
  email_placeholder: "EMAIL",
  watch_now: "Watch Now",
  sign_up_below_to: "Sign Up below to",
  join_beta: "Join the beta",
  join_now: "Join Now",
  try_switching_themes: "Try Switching Themes",
  activated: "Activated",
  core_features_title: "Core Features That Matter",
  core_features_subtitle: "MagicTask has been made as simple as possible, but no simpler. -Albert Einstein",
  simplest_system: "Designed for simplicity.",
  to_organize: "Clean, Simple Elegant UI's",
  personalize_themes: "Declutter your life.",
  collect_themes_to_personalize: "Prioritize between work and life.",
  level_up_themes: "Performant",
  to_unlock_new_styles: "Designed for speed and ease of use.",
  buy_sell_themes: "Theme Marketplace",
  earn_money: "Have fun while getting things done.",
  monthly_theme: "Designed for gamers by gamers",
  exclusive_themes: "New features will be designed for the gaming community.",
  live_support: "Live Support",
  get_more_productivity: "Increase productivity with less effort",
  productivity1: "Declutter your mind",
  productivity2: "Focus on the work that matters",
  productivity3: "Drastically boost your productivity by working smarter",
  step_process_title: "Simple 4-Step Process",
  step_process_subtitle: 'Flexible enough to use BYOM "Bring your own methodology"',
  step1: "Step 1",
  step1_title: "Capture",
  step1_subtitle: "",
  step2: "Step 2",
  step2_title: "Clarify",
  step2_subtitle: "",
  step3: "Step 3",
  step3_title: "Prioritize",
  step3_subtitle: "",
  step4: "Step 4",
  step4_title: "Execute",
  step4_subtitle: "",
  total_downloads: "Alpha Testing",
  happy_customers: "Tasks Created",
  active_accounts: "Active Accounts",
  tickets_closed: "Tasks Completed",
  what_customers_say: "What customers are saying about MagicTask",
  join_people: "MagicTask is an infinitely flexible tool that is simple.",
  join_people_subtitle: "The problem with today's society is the abundance and instant nature of data.  Organization, prioritization and retention of all of this data is near impossible.  If you use a complex tool to try to manage these problems it doesn't solve the underlying problems, it creates new ones.",
  welcome_to_magictask: "Welcome to MagicTask",
  have_questions: "Frequently asked questions",
  what_is_mt: "1. What is MagicTask?",
  what_is_mt_ans: "MagicTask is an infinitely flexible tool that is simple. Each person can use it differently and for different reasons/etc.",
  why_mt_created: "2. Why was MagicTask created?",
  why_mt_created_ans: "MagicTask was created out of the frustration for overly complex project management tools, such as Jira/Monday.com/",
  what_is_mt_vision: "3. What is the long term vision of MagicTask?",
  what_is_mt_vision_ans: "MagicTask is trying to be the first and only task management system that is actually a game.",
  can_i_use_for_agile: "4. Can I use MagicTask for Agile projects?",
  can_i_use_for_agile_ans: "Yes you can, we have been using it for our service based company to run all of our agile projects since 2019.  Here is a video with more information:",
  can_i_use_for_agile_link: "https://www.youtube.com/watch?v=Yucko3SkbEg",
  is_mt_free: "5. Is MagicTask free?",
  is_mt_free_ans: "Yes, it is currently free to use.  However, this may change in the future based on our beta testing.  Currently we are planning to generate revenue through the sale of themes in our marketplace.",
  is_mt_around_gtd: "6. Is MagicTask built around the GTD(Getting things done methodology)?",
  is_mt_around_gtd_ans: 'No, we actually developed our own simplistic methodology called the "Top Down Methodology".  However, MagicTask is designed in such a flexible tool you can apply almost any productivity methodology to it and it will function better than most tools.',
  is_there_any_video: "7. Is there any video content describing the basic MagicTask features and uses?",
  is_there_any_video_ans: "Yes you can view this video for more information:",
  is_there_any_video_link: "https://www.youtube.com/watch?v=C1U64cULGCM",
  does_mt_sell_data: "8. Does MagicTask sell my data?",
  does_mt_sell_data_ans: "NO! MagicTask does not believe in selling data.",
  who_developed_mt: "9. Who developed MagicTask?",
  who_developed_mt_ans: "Imaginovation, LLC",
  who_developed_mt_link: "https://www.imaginovation.net",
  sign_up_now: "Sign up now",
  lets_make_something_great: "Let's make something great together",
  lets_make_something_great_subtitle: "Here at MagicTask we are constantly innovating.  We take each and every piece of feedback that we receive, analyze it, blend it into our 10 years of experience in building custom applications.  Join the system today and let's build the greatest task management system ever created.",
  full_name: 'Your Full Name',
  email: 'Your Email',
  phone_number: 'Your Phone Number',
  let_know_more: 'Project Description',
  iQuestion: 'How did you hear about us?',
  send_now: 'Send Now',
  download: 'Download',
  enter_full_name: 'Enter Your Full Name',
  enter_email: 'Enter Your Email',
  enter_phone_number: 'Enter Your Phone Number'
};
